import store from '@/store/index.js';
import pixNProgress from '@/shared/pixNProgress.js';

export default async (to, from, next) => {
  try {
    await store.dispatch('mandateModule/fetchMandateById', to.params.mandateId);

    if (to.meta.mode) {
      store.commit('mandateModule/setMode', to.meta.mode);
    }
    next();
  } catch (error) {
    store.dispatch('toastModule/error', 'mandate.errorLoadingProperty');
    pixNProgress.forceFinish();
    next(false);
  }
};
